import * as React from 'react';
import styled from 'styled-components';
import { FormattedMessage, IntlProvider } from 'react-intl';

import { withLocale } from '../../dashboard/contexts/locale.context';
import { MeasurementIndex } from '../../dashboard/enums/measurement.enum';
import { indexToColor } from '../../utils/index-to-color.util';
import { fontWeights, grayScale } from '../inline-styles/variables';
import SensorDot from './SensorDot';
import { messages } from '../../../locale/messages';
import { Locale } from 'src/app/dashboard/enums/locale.enum';

interface Props {
  value: string;
  index: number | null;
  type: MeasurementIndex;
  locale: Locale;
}

const StSensorDotLabel = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  & + & {
    margin: 16px 0 0;
  }
`;

const StLeftGroup = styled.div`
  display: flex;
  align-items: center;
`;

const StSensorLabelName = styled.span`
  font-size: 1.25rem;
  line-height: 1.6;
  color: ${grayScale['4']};
  margin: 0 0 0 8px;
`;

const StSensorLabelValue = styled.span`
  font-size: 1.5rem;
  font-weight: ${fontWeights.regular};
  color: #ffffff;
`;

class SensorDotLabel extends React.Component<Props> {
  render() {
    const { value, index, type, locale } = this.props;

    return (
      <IntlProvider locale={locale} messages={messages[locale]}>
        <StSensorDotLabel>
          <StLeftGroup>
            <SensorDot color={indexToColor(index)} />
            <StSensorLabelName>
              <FormattedMessage id={type} />
            </StSensorLabelName>
          </StLeftGroup>
          <StSensorLabelValue>{value}</StSensorLabelValue>
        </StSensorDotLabel>
      </IntlProvider>
    );
  }
}

export default withLocale(SensorDotLabel);



// WEBPACK FOOTER //
// ./src/app/ui/components/SensorDotLabel.tsx